module.exports = __webpack_public_path__ + "static/cards_monei-9331ef525ae16751d89941e9cefa9a72.svg";